/**
 * Maps sites/apps data into array of { value: String, name: String, type: String }
 *
 * @param originalData
 * @param splitApps - if true, type property gets added
 * @returns {*[]}
 */
export const transpileDataForFilters = (originalData, splitApps, allSelected) => {
    const transpiledData = [];

    if (splitApps) {
        const types = Object.keys(originalData) || [];
        types.forEach(type => {
            Object.keys(originalData[type]).forEach(itemUUID => {
                transpiledData.push({value: itemUUID, name: originalData[type][itemUUID], type, selected: allSelected})
            });
        });
    } else {
        Object.keys(originalData).forEach(itemUUID => {
            allSelected ? transpiledData.push({value: itemUUID, name: originalData[itemUUID], selected: allSelected}) :
            transpiledData.push({value: itemUUID, name: originalData[itemUUID]})
        });
    }

    return transpiledData
}
export const transpileDataForSiteInitialFilters = (originalData) => {
    const transpiledData = [];
    const types = Object.keys(originalData) || [];
    types.forEach(type => {
        Object.keys(originalData[type]).forEach(itemUUID => {
            transpiledData.push(itemUUID)
        });
    });
    return transpiledData
}
export const transpileDataForCountriesInitialFilters = (originalData) => {
    const transpiledData = [];
    Object.keys(originalData).forEach(itemUUID => {
        transpiledData.push(itemUUID)
    });
    return transpiledData
}
